export default __webpack_public_path__ + "static/media/associations.4f66e59a.svg";